import React, { useState } from "react";
import "./FollowPopup.css";

function FollowPopup({ visible, onClose, onFollow, lang = "en" }) {
  const [inputValue, setInputValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  if (!visible) {
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!inputValue.trim()) {
      setError(lang === "nl" ? "Voer een gebruikersnaam of e-mailadres in." : "Please enter a username or email address.");
      return;
    }

    setIsSubmitting(true);
    setError("");
    setSuccessMessage("");

    try {
      const result = await onFollow(inputValue.trim());
      const username = result?.username || inputValue.trim();
      setSuccessMessage(
        lang === "nl" 
          ? `Je volgt nu '${username}'.`
          : `You are now following '${username}'.`
      );
      setInputValue("");
      
      // Close popup after 2 seconds
      setTimeout(() => {
        setSuccessMessage("");
        onClose();
      }, 2000);
    } catch (err) {
      setError(
        err.message || 
        (lang === "nl" 
          ? "Kon gebruiker niet toevoegen. Probeer het opnieuw." 
          : "Could not add user. Please try again.")
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setInputValue("");
      setError("");
      setSuccessMessage("");
      onClose();
    }
  };

  return (
    <>
      <div className="follow-popup-overlay" onClick={(e) => {
        if (e.target === e.currentTarget) {
          e.stopPropagation();
          handleClose();
        }
      }} />
      <div
        className="follow-popup"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="follow-popup-close"
          onClick={handleClose}
          aria-label="Close"
          disabled={isSubmitting}
        >
          ×
        </button>

        <div className="follow-popup-content">
          {!successMessage && (
            <div className="follow-popup-title">
              {lang === "nl"
                ? "Je ziet alleen de top 50. Iemand altijd én duidelijker in de competitie zien?\n\nVul de gebruikersnaam of het e-mailadres in, of klik op een speler in de lijst om deze te volgen."
                : "You only see the top 50. Want to see someone always and clearer in the competition?\n\nEnter their username or email address, or simply click a player in the list to follow them."}
            </div>
          )}

          {successMessage && (
            <div className="follow-popup-success">{successMessage}</div>
          )}

          <form onSubmit={handleSubmit}>
            {!successMessage && (
              <>
                <input
                  type="text"
                  className="follow-popup-input"
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    setError("");
                  }}
                  placeholder={
                    lang === "nl"
                      ? "Gebruikersnaam of e-mailadres"
                      : "Username or email address"
                  }
                  disabled={isSubmitting}
                />

                {error && (
                  <div className="follow-popup-error">{error}</div>
                )}
              </>
            )}

            <div className="follow-popup-actions">
              <button
                type="button"
                className="follow-popup-cancel"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                {lang === "nl" ? "Annuleren" : "Cancel"}
              </button>
              {!successMessage && (
                <button
                  type="submit"
                  className="follow-popup-submit"
                  disabled={isSubmitting || !inputValue.trim()}
                >
                  {isSubmitting
                    ? lang === "nl"
                      ? "Toevoegen..."
                      : "Adding..."
                    : lang === "nl"
                    ? "OK"
                    : "OK"}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default FollowPopup;

